import classNames from 'classnames'
import Link from 'next/link'
import { ReactNode } from 'react'

import Icon from '@/components/Icon/Icon'

import styles from './SubNav.module.scss'

type Props = {
  dropdowns?: boolean
  grid?: boolean
  header?: string
  items: Array<{
    colors?: string[]
    image?: React.ReactNode
    selected?: boolean
    textLeft: string
    textRight?: string
    url: string
  }>
}

const SubNav = ({ dropdowns, grid, header, items }: Props) => (
  <div className={styles.container}>
    {!grid && (
      <div className={classNames('align-items-center d-flex', styles.item, { 'mb-2': !dropdowns })}>
        <span className='ms-2'>{header}</span>
        <span className='ms-2'>
          <Icon icon='caretDown' size='sm' />
        </span>
      </div>
    )}
    <div
      className={classNames(styles.dropdown, { [styles.grid]: grid, 'd-grid p-0 position-static w-100': !dropdowns })}
    >
      {items?.map(({ colors, image, selected, textLeft, textRight, url }) => {
        const WrapperComponent = ({ children }: { children: ReactNode }) =>
          selected ? (
            <div className={styles.button}>{children}</div>
          ) : (
            <Link className={styles.button} href={url}>
              {children}
            </Link>
          )
        return (
          <div
            className={classNames(styles.item, {
              [styles.selected]: selected,
              [styles.small]: colors && colors.length >= 4,
            })}
            key={url}
          >
            <WrapperComponent>
              <div className={styles.image}>{image}</div>
              <div className='align-items-center d-flex flex-1 justify-content-between w-100'>
                <span className={styles.textLeft}>{textLeft}</span>
                <span className={styles.textRight}>{textRight}</span>
              </div>
            </WrapperComponent>
          </div>
        )
      })}
    </div>
  </div>
)

export default SubNav
